import { Interaction } from './interaction';
import Draw from 'ol/interaction/Draw';

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

import { transform } from 'ol/proj';
import { getDistance } from 'ol/sphere';
import { unByKey } from 'ol/Observable';

const measure = (style, target, sourceProj) => {   
	const source = new VectorSource();
    const distance = new VectorLayer({
        source: source,
        style: style
    }); 
                
    const draw = new Draw({
        style : style,
        source: source,            
        type: 'LineString'
    //    maxPoints: 2      
    });    
        
    const formatLength = (line) => {
       let length = 0;
       const coordinates = line.getCoordinates();
          
       for (let i = 0, ii = coordinates.length - 1; i < ii; ++i) {
           const c1 = transform(coordinates[i], sourceProj, 'EPSG:4326');
           const c2 = transform(coordinates[i + 1], sourceProj, 'EPSG:4326');
           length += getDistance(c1, c2);
       }
          
       let output;
       if (length > 100) {
           output = (Math.round(length / 1000 * 100) / 100) + ' ' + 'km';
       } else {
           output = (Math.round(length * 100) / 100) + ' ' + 'm';
       }
           
       return output;
    };
    
    let listenerKey = null;
    let sketch;
    
    draw.on('drawstart', ({feature}) => {
      sketch = feature;

      listenerKey = sketch.getGeometry().on('change', (e) => {
          	const geom = e.target;
          	target.innerHTML = formatLength(geom);
          });
  	});
        
    draw.on('drawend', e => {
    	unByKey(listenerKey);

        sketch = null;
            
        let currentFeatures = source.getFeatures();
        for (let i = 0, l = currentFeatures.length; i < l; i++) {
        	let f = currentFeatures[i];
            if (f !== e.feature) {
            	source.removeFeature(f);
            }
        }
    });
        
    draw.on('change:active', (e) => { 
    	let active = e.target.getActive();
        let map = e.target.getMap();
            
        target.parentElement.style.display = e.target.getActive() ? 'initial' : 'none';
            
        if( !active ) {
        	map = null;
            source.clear();
        }
            
        distance.setMap(map);
            
        target.innerHTML = '';
    });
    
    draw.setActive(false);
    return new Interaction(draw);  
}

export {
	measure
}
